var app = angular.module('leonardo');

var FixedHeadDirective = function(deviceDetector, $timeout, $window, BrowserService) {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {

      scope.lastPosElement = 0;
      scope.left = BrowserService.isMobile() ? element.position().left : element.position().left + 270;
      scope.head_height = angular.element('.zone-header').outerHeight();
      scope.isEdge = _.contains(['ms-edge', 'ie'], deviceDetector.browser);

      scope.resizeHeaders = function() {
        if (scope.head && scope.new_head) {
          var width = scope.head.parent().outerWidth();
          var width_wrapper = scope.head.parent().parent().outerWidth();
          if (width > width_wrapper) {
            scope.new_head.css({width: width_wrapper, overflow: 'hidden'});
          }
          else {
            scope.new_head.css({width: width});
          }
          if (scope.mode === 'table') {
            scope.new_head.find('tr').css({width: width, display: 'table'});
          }
          scope.head_height = angular.element('.zone-header').outerHeight();
          scope.new_head.css({top: scope.head_height});
        }
      };

      angular.element('.wrapper-columns-column.region-main .content-column').scroll(function(){
        scope.head_height = angular.element('.region-main .zone-header').outerHeight();
        if (element.is(':visible')) {

          scope.currPosElement = angular.element('.wrapper-columns-column.region-main .content-column').scrollLeft();
          if (scope.lastPosElement != scope.currPosElement) {
            scope.scrollEvent('head', scope.currPosElement);
          }

          if (attrs.fixedHead) {
            scope.head = element.find('.'+attrs.fixedHead);
          }
          else {
            scope.head = element.find('.thead');
          }
          if (!scope.head || scope.head.length == 0){
            scope.head = element.find('thead');
            scope.mode = 'table';
          }
          scope.left = BrowserService.isMobile() ? scope.head.position().left : scope.head.position().left + 270;

          scope.head_bottom = element.offset().top +
            element.outerHeight() - scope.head_height;


          if (scope.head){

            var headers = [];
            if (scope.mode === 'table') {
              headers = scope.head.find('th');
            }
            else {
              headers = scope.head.find('.th');
            }

            if ((scope.head.offset().top <= scope.head_height) &&
              (scope.head_bottom >= 0)){

              if (!element.hasClass('fixed')){

                if (!attrs.widthAuto) {
                  angular.forEach(headers, function(value){
                    angular.element(value).css({width: angular.element(value).outerWidth()});
                  });
                }

                element.addClass('fixed');
                scope.new_head = scope.head.clone();
                scope.new_head.addClass('fixed_head');
                scope.head.after(scope.new_head);
                scope.resizeHeaders();
                scope.scrollEvent('head', element.parent().scrollLeft());
              }
              scope.new_head.css({top: scope.head_height});
            }
            else {
              if (element.hasClass('fixed')){
                if (!attrs.widthAuto) {
                  angular.forEach(headers, function(value){
                    angular.element(value).css({width: ''});
                  });
                }
                scope.new_head.css({width: 'inherit'});
                element.removeClass('fixed');
                scope.new_head.remove();
              }
            }
          }
        }
        else {
          if (element.hasClass('fixed')){
            scope.new_head.css({width: 'inherit'});
            element.removeClass('fixed');
            scope.new_head.remove();
          }
        }
      });

      scope.scrollEvent = function(mode, currentPos) {
        switch (mode) {
          case 'head':
            if (scope.new_head){
              if (scope.isEdge) {
                $timeout(function() {
                  var left = parseInt(scope.left);
                  scope.new_head.css({left: left});
                  scope.$apply();
                }, 50);
              }
              else {
                var left1 = parseInt(scope.left);
                scope.new_head.css({left: left1});
                scope.$apply();
              }
            }
            break;
          case 'element':
            element.parent().scrollLeft(currentPos);
            break;
        }
        scope.lastPosElement = currentPos;
      };

      angular.element($window).bind('resize', function(){
        $timeout(function () {
          scope.resizeHeaders();
          scope.scrollEvent('head', element.parent().scrollLeft());
        }, 10);
      });

      scope.$on('$destroy', function() {
        angular.element('.wrapper-columns-column.region-main .content-column').off('scroll', function(){
          // This is intentional do_something blank function
        });
        element.parent().off('scroll', function(){
          // This is intentional do_something blank function
        });
        if(scope.new_head) {
          scope.new_head.off('scroll', function(){
            // This is intentional do_something blank function
          });
        }
      });
    }
  };
};

app.directive('fixedHead', ['deviceDetector', '$timeout', '$window', 'BrowserService', FixedHeadDirective]);
